import datalayer from 'lib/datalayer'

/**
 * This is a Vue.js mixin that checks for
 * a datalayer method on child components. If the method
 * exists it runs the method and ensures that the form
 * does not submit if the method returns a falsy value.
 */
export default {
  methods: {
    dataLayerPush (name, data) {
      return datalayer.dataLayerPush(name, data)
    }
  }
}
